var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "INDIA_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000155111416233197402490000007183476236431439022_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000155111416233197402490000007183476236431439022__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.6802 0.804688H0.117188V7.3317H33.6802V0.804688Z",
    fill: "#F0953E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000155111416233197402490000007183476236431439022__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.6802 13.8584H0.117188V20.3814H33.6802V13.8584Z",
    fill: "#3B8916"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000155111416233197402490000007183476236431439022__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_38837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000059269777640460758120000018211146353377130661_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.8979 7.66016C15.2769 7.66016 13.96 8.97315 13.96 10.5941C13.96 12.2151 15.2759 13.5322 16.8979 13.5322C18.5199 13.5322 19.8359 12.2161 19.8359 10.5941C19.8339 8.97315 18.5189 7.66016 16.8979 7.66016ZM16.8959 7.94516L16.822 9.42215L16.9019 10.2621L16.976 9.42215L16.9019 7.94516C16.9799 7.94516 17.054 7.94915 17.129 7.95715C17.129 7.96115 17.1249 7.96115 17.1249 7.96515C17.1249 8.03515 17.1799 8.09415 17.2459 8.09415C17.3089 8.09415 17.3589 8.04314 17.3649 7.98514C17.4389 8.00114 17.5099 8.01216 17.5819 8.03616L17.129 9.44214L16.9839 10.2741L17.2769 9.47714L17.59 8.03616C17.66 8.05916 17.731 8.07914 17.801 8.10614C17.797 8.11814 17.791 8.13314 17.791 8.14914C17.791 8.21514 17.8459 8.27014 17.9139 8.27014C17.9609 8.27014 18.008 8.23917 18.025 8.19617C18.091 8.22717 18.1559 8.26215 18.2219 8.30115L17.4189 9.53516L17.064 10.3082L17.554 9.61716L18.228 8.30414C18.289 8.33914 18.3509 8.37814 18.4139 8.41714C18.3959 8.44014 18.387 8.46415 18.387 8.49515C18.387 8.56115 18.4419 8.61615 18.5099 8.61615C18.5489 8.61615 18.584 8.60016 18.606 8.56516C18.665 8.61616 18.719 8.66716 18.77 8.71716L17.676 9.70514L17.1349 10.3571L17.7849 9.81815L18.775 8.72015C18.826 8.77515 18.8769 8.82516 18.9229 8.88416C18.8939 8.90716 18.8799 8.94315 18.8799 8.97815C18.8799 9.04415 18.935 9.09915 18.999 9.09915C19.028 9.09915 19.0499 9.09114 19.0709 9.07614C19.1159 9.13914 19.1549 9.20116 19.1899 9.26416L17.877 9.93616L17.1859 10.4282L17.9539 10.0761L19.1939 9.26715C19.2349 9.33715 19.268 9.41215 19.301 9.47415C19.26 9.49415 19.2269 9.54016 19.2269 9.59116C19.2269 9.65716 19.2819 9.71216 19.3459 9.71216C19.3649 9.71216 19.3789 9.70816 19.3929 9.70016C19.4169 9.77016 19.4379 9.83717 19.4559 9.90717L18.0129 10.2122L17.2219 10.5052L18.054 10.3642L19.46 9.91516C19.478 9.97816 19.4949 10.0562 19.5089 10.1262C19.4479 10.1342 19.403 10.1812 19.403 10.2472C19.403 10.3132 19.4599 10.3682 19.5259 10.3682C19.5299 10.3682 19.534 10.3682 19.538 10.3682C19.546 10.4382 19.546 10.5162 19.546 10.5872L18.0729 10.5172L17.2289 10.5912L18.0729 10.6732L19.546 10.5952C19.546 10.6732 19.546 10.7471 19.538 10.8181C19.534 10.8181 19.5299 10.8181 19.5259 10.8181C19.4599 10.8181 19.403 10.8771 19.403 10.9391C19.403 11.0011 19.448 11.0482 19.507 11.0602C19.493 11.1342 19.478 11.2051 19.46 11.2751L18.9579 11.1151L18.054 10.8221L17.2219 10.6812L18.0129 10.9742L19.4559 11.2831C19.4389 11.3531 19.417 11.4281 19.39 11.4901C19.386 11.4901 19.378 11.4861 19.374 11.4861C19.362 11.4861 19.3549 11.4861 19.3469 11.4861C19.2789 11.4861 19.2239 11.5371 19.2239 11.6071C19.2239 11.6271 19.228 11.6381 19.236 11.6541C19.242 11.6741 19.2539 11.6891 19.2689 11.7011C19.2729 11.7011 19.2749 11.7051 19.2789 11.7051C19.2829 11.7091 19.287 11.7132 19.291 11.7132C19.293 11.7132 19.297 11.7172 19.299 11.7212C19.268 11.7872 19.2329 11.8541 19.1949 11.9161L17.9569 11.1151H17.955L17.187 10.7632H17.1909L17.593 11.0442L17.8779 11.2472L19.1909 11.9192C19.1519 11.9852 19.1129 12.0521 19.0699 12.1101C19.0499 12.0981 19.0249 12.0901 18.9999 12.0901C18.9319 12.0901 18.879 12.1412 18.879 12.2072C18.879 12.2462 18.895 12.2811 18.924 12.3011C18.875 12.3561 18.8259 12.4102 18.7759 12.4612L17.7859 11.3672L17.1379 10.8282L17.6769 11.4802L18.7709 12.4681C18.7199 12.5231 18.6699 12.5662 18.6129 12.6132C18.5899 12.5932 18.5639 12.5862 18.5369 12.5862C18.4709 12.5862 18.416 12.6452 18.416 12.7072C18.416 12.7302 18.42 12.7461 18.426 12.7621C18.362 12.8011 18.295 12.8441 18.231 12.8871L17.5569 11.5742L17.067 10.8792L17.421 11.6491L18.2239 12.8911C18.1599 12.9261 18.0949 12.9612 18.0289 12.9932C18.0109 12.9462 17.9679 12.9192 17.9199 12.9192C17.8519 12.9192 17.7969 12.9782 17.7969 13.0402C17.7969 13.0562 17.8009 13.0712 17.8049 13.0872C17.7349 13.1102 17.6659 13.1341 17.5939 13.1501L17.2809 11.7051L16.9879 10.9202V10.9161L17.1329 11.7481L17.5859 13.1541C17.5139 13.1741 17.442 13.1931 17.369 13.2011C17.359 13.1461 17.3089 13.0992 17.2499 13.0992C17.1799 13.0992 17.129 13.1542 17.129 13.2162C17.129 13.2242 17.129 13.2281 17.129 13.2321C17.055 13.2401 16.9809 13.2441 16.9059 13.2441L16.9799 11.7711L16.9019 10.9272L16.8259 11.7711L16.9 13.2441C16.822 13.2441 16.7499 13.2401 16.6729 13.2321C16.6729 13.2281 16.6729 13.2242 16.6729 13.2162C16.6729 13.1532 16.6179 13.0992 16.5499 13.0992C16.4909 13.0992 16.441 13.1461 16.431 13.2011C16.359 13.1891 16.2889 13.1741 16.2199 13.1541L16.6729 11.7481L16.814 10.9202L16.5209 11.7051L16.2119 13.1501C16.1419 13.1341 16.071 13.1112 15.999 13.0872C16.005 13.0712 16.0089 13.0562 16.0089 13.0402C16.0089 12.9772 15.954 12.9192 15.89 12.9192C15.839 12.9192 15.796 12.9502 15.775 12.9932C15.71 12.9622 15.644 12.9271 15.58 12.8911L16.3829 11.6491L16.7349 10.8792L16.2469 11.5702L15.575 12.8861C15.511 12.8431 15.4459 12.8041 15.3859 12.7611C15.3999 12.7451 15.4089 12.7222 15.4089 12.6952C15.4089 12.6252 15.3539 12.5702 15.2899 12.5702C15.2489 12.5702 15.2159 12.5902 15.1959 12.6172C15.1369 12.5662 15.0829 12.5231 15.0319 12.4691L16.1299 11.4811L16.6689 10.8292L16.0189 11.3682L15.0289 12.4622C14.9739 12.4112 14.926 12.3532 14.877 12.3022C14.904 12.2792 14.924 12.2432 14.924 12.2042C14.924 12.1382 14.8689 12.0872 14.8029 12.0872C14.7759 12.0872 14.75 12.0951 14.731 12.1071C14.688 12.0481 14.6489 11.9862 14.6119 11.9192L15.9279 11.2432L16.614 10.7632L15.8459 11.1151L14.6079 11.9161C14.5709 11.8531 14.5419 11.7912 14.5079 11.7212C14.5549 11.7052 14.5859 11.6622 14.5859 11.6122C14.5859 11.5422 14.533 11.4872 14.463 11.4872C14.446 11.4872 14.4279 11.4911 14.4119 11.4991C14.3889 11.4331 14.3649 11.3581 14.3439 11.2841L15.7889 10.9752L16.5839 10.6822L15.7479 10.8232L14.3419 11.2762C14.3229 11.2062 14.309 11.1352 14.293 11.0572C14.354 11.0492 14.3979 11.0022 14.3979 10.9402C14.3979 10.8742 14.3429 10.8192 14.2769 10.8192C14.2729 10.8192 14.2669 10.8192 14.2629 10.8192C14.2589 10.7492 14.2529 10.6742 14.2529 10.5962L15.728 10.6742L16.5699 10.5922L15.728 10.5182L14.2529 10.5882C14.2529 10.5182 14.2589 10.4401 14.2629 10.3691C14.2709 10.3691 14.2769 10.3691 14.2839 10.3691C14.3499 10.3691 14.405 10.3181 14.405 10.2481C14.405 10.1821 14.3559 10.1352 14.2919 10.1272C14.3079 10.0572 14.3209 9.97914 14.3409 9.91614L15.7469 10.3651L16.5829 10.5062L15.788 10.2132L14.343 9.90414C14.364 9.83014 14.3879 9.75915 14.4109 9.69315C14.4229 9.69715 14.4419 9.70114 14.4559 9.70114C14.5239 9.70114 14.577 9.64614 14.577 9.58014C14.577 9.52914 14.5459 9.48616 14.5049 9.47116C14.5359 9.40116 14.5699 9.33416 14.6069 9.26816L15.8449 10.0771L16.6169 10.4291L15.9279 9.93716L14.6119 9.26517C14.6489 9.20217 14.6899 9.14016 14.7329 9.07416C14.7499 9.09416 14.7799 9.10117 14.8049 9.10117C14.8689 9.10117 14.926 9.04616 14.926 8.98016C14.926 8.94516 14.9059 8.91014 14.8809 8.88214C14.9259 8.82714 14.9749 8.77714 15.0269 8.72214L16.017 9.82016L16.6689 10.3592L16.1299 9.70715L15.0319 8.71915C15.0869 8.66815 15.1399 8.61717 15.1959 8.57117C15.2149 8.59817 15.2509 8.61816 15.2899 8.61816C15.3579 8.61816 15.413 8.56316 15.413 8.49316C15.413 8.46616 15.4009 8.44216 15.3879 8.41916C15.4509 8.38416 15.5109 8.34115 15.5759 8.30615L16.2479 9.61914L16.736 10.3072L16.3839 9.53714L15.5809 8.30316C15.6449 8.26416 15.7099 8.22915 15.7739 8.19815C15.7939 8.24515 15.837 8.27615 15.887 8.27615C15.955 8.27615 16.0079 8.22115 16.0079 8.15915C16.0079 8.13915 16.0039 8.12015 15.9999 8.10815C16.0679 8.08115 16.143 8.06115 16.213 8.03815L16.5259 9.47916L16.8189 10.2762L16.676 9.44415L16.223 8.03815C16.293 8.01515 16.3639 8.00315 16.4379 7.98715C16.4459 8.04615 16.4969 8.09216 16.5569 8.09216C16.6249 8.09216 16.6799 8.03716 16.6799 7.96716C16.6799 7.96316 16.6799 7.95914 16.6799 7.95514C16.7479 7.94514 16.8219 7.94516 16.8959 7.94516Z",
    fill: "#16007E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000059269777640460758120000018211146353377130661__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16.9019 10.1553C17.1439 10.1553 17.34 10.3543 17.34 10.5933C17.34 10.8353 17.1449 11.0343 16.9019 11.0343C16.6559 11.0343 16.4609 10.8353 16.4609 10.5933C16.4609 10.3543 16.6559 10.1553 16.9019 10.1553Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_38837",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000059269777640460758120000018211146353377130661__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.6802 0.804688H0.117188V20.3827H33.6802V0.804688Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_38837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M16.9026 10.2578C17.0886 10.2578 17.2406 10.4058 17.2406 10.5938C17.2406 10.7848 17.0886 10.9378 16.9026 10.9378C16.7136 10.9378 16.5586 10.7858 16.5586 10.5938C16.5596 10.4058 16.7136 10.2578 16.9026 10.2578Z",
    fill: "#16007E"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/INDIA.edaf8233fc9ec47601cb5b7bdd1c1dc8.svg";
export { ForwardRef as ReactComponent };